import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import CustomeButton from "../../Button/index";
import { Skeleton } from "primereact/skeleton";
import EmptyDataView from "../../../components/nodataview";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";

import "./entitydashboard.scss";
import icon from "../../../assets/images/no-service.png";
import { CURRENT_ENVIRONMENT } from "~/config/env";
import { useSelector } from "react-redux";

const AppsServices = ({ data, load, lspserviceurl }) => {
  const navigate = useNavigate();
  const cardContainerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { role } = useSelector((state) => state.login);
  const entityData = useSelector((state) => state.globalEntities.entity_detail);
  const { value: isEntityCalendarEnabled } = useFeatureFlag(
    "entity-calendar",
    false,
  );
  const { payslip_portal_link: userPayslipPortalLink } = useSelector(
    (state) => state.inviteusers,
  );

  const resolvePayslipUrl = () => {
    if (role === "LSP_USER" || role === "LSP_MANAGER") {
      return userPayslipPortalLink;
    } else {
      if (CURRENT_ENVIRONMENT === "STAG" || CURRENT_ENVIRONMENT === "DEV") {
        return "https://hsp.pay-preprod.com/";
      } else {
        return "https://hsp.payslip.com";
      }
    }
  };
  const { value: isRequestsFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.REQUESTS,
    false,
  );

  const handleOpen = (url) => {
    if (url === "event") {
      navigate(`/entity/${data.id}/calendar`);
    } else {
      window.open(url);
    }
  };
  const services = data?.active_services
    ? [...data.active_services].sort((a, b) => a.name.localeCompare(b.name))
    : [];

  useEffect(() => {
    const el = cardContainerRef.current;
    if (el) {
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, [services]);

  const handleCarouselDirection = (direction) => {
    if (direction === "left") {
      cardContainerRef.current.scrollBy({ left: -350, behavior: "smooth" });
    }
    if (direction === "right") {
      cardContainerRef.current.scrollBy({ left: 350, behavior: "smooth" });
    }
  };
  return (
    <div className="apps-services-container">
      <div className="heading-container">
        <h4 className="heading">Your Services & Apps</h4>
        <p className="desc">Find all the services & apps we have for you</p>
      </div>
      {load ? (
        <div className="cards-container">
          {[1, 2].map((_, index) => (
            <div className="card skeleton-card" key={index}>
              <div className="icon-container">
                <Skeleton width="3rem" height="3rem" shape="circle" />
              </div>
              <p className="card-name">
                <Skeleton width="8rem" height="1.5rem" />
              </p>
              <p className="desc">
                <Skeleton width="12rem" height="1rem" />
              </p>
              <div className="button-container">
                <Skeleton width="6rem" height="2rem" className="m-1" />
                <Skeleton width="6rem" height="2rem" className="m-1" />
              </div>
            </div>
          ))}
        </div>
      ) : services.length > 0 ? (
        <div>
          <div className="cards-container" ref={cardContainerRef}>
            {services.map((item) => {
              const openUrl =
                item?.name === "Payroll +"
                  ? resolvePayslipUrl()
                  : lspserviceurl?.find(
                      (service) => Object.keys(service)[0] === item?.id,
                    )?.[item.id]?.[0] ||
                    item?.payslip_url?.[0] ||
                    "";
              const contactUrl = item?.payslip_url
                ? item?.payslip_url[1]
                : null;
              return (
                <div className="card" key={item?.id}>
                  <div className="icon-container">
                    <div
                      className="service__icon__container"
                      style={{
                        backgroundColor: item.secondary_color,
                      }}
                      dangerouslySetInnerHTML={{ __html: item?.icon }}
                    />
                  </div>
                  <p className="card-name">{item?.name}</p>
                  <p className="desc">{item?.description}</p>
                  <div className="button-container">
                    {openUrl && (
                      <CustomeButton
                        label="Open"
                        variant="outlined"
                        className="card-button"
                        onClick={() => handleOpen(openUrl)}
                      />
                    )}
                    {isEntityCalendarEnabled && (
                      <CustomeButton
                        label="View Events"
                        variant="outlined"
                        className="card-button"
                        onClick={() => handleOpen("event")}
                      />
                    )}
                    {!isRequestsFeatureEnabled &&
                      ["Payroll +", "EoR"].includes(item?.name) &&
                      contactUrl && (
                        <CustomeButton
                          label="Contact Us"
                          variant="outlined"
                          className="card-button"
                          onClick={() => handleOpen(contactUrl)}
                        />
                      )}
                  </div>
                </div>
              );
            })}
          </div>
          {isOverflowing && (
            <div className="carousel-button-container">
              <Button
                outlined
                icon="pi pi-angle-left"
                onClick={() => handleCarouselDirection("left")}
              />
              <Button
                outlined
                icon="pi pi-angle-right"
                onClick={() => handleCarouselDirection("right")}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={icon}
                alt="Users Icon"
              />
            }
            Header={"No Services or Apps Yet"}
            Description={
              "This Parent is not using any services or apps at the moment."
            }
          />
        </div>
      )}
    </div>
  );
};
AppsServices.propTypes = {
  data: PropTypes.object,
  load: PropTypes.bool,
  lspserviceurl: PropTypes.array,
};
export default AppsServices;
